export default __webpack_public_path__ + "static/media/exams.51cf804b.svg";